
import Group from 'vux/src/components/group/index.vue'
import CellBox from 'vux/src/components/cell-box/index.vue'
import Tab from 'vux/src/components/tab/tab.vue'
import TabItem from 'vux/src/components/tab/tab-item.vue'
import Flexbox from 'vux/src/components/flexbox/flexbox.vue'
import FlexboxItem from 'vux/src/components/flexbox/flexbox-item.vue'
import XButton from 'vux/src/components/x-button/index.vue'
import XTable from 'vux/src/components/x-table/index.vue'
import Loading from 'vux/src/components/loading/index.vue'

export default{
components: {
Group,
CellBox,
Tab,
TabItem,
Flexbox,
FlexboxItem,
XButton,
XTable,
Loading
},
data(){
return{
dataCourse:[],
dataVideo:[],
dataQtn:[],
tabsParam:[['课程','Coll1'],['视频','Coll2'],['问答','Coll3']],
nowIndex:0,//默认第一个tab为激活状态
WebUrl:""
}
},
created(){
this.$nextTick(() => {

this.$vux.loading.show({
text: 'Loading'
})

this.toggleTabs(0);
this.WebUrl=this.$api.URL;

setTimeout(() => {
this.$vux.loading.hide()
}, 1000)
})

},
methods:{

toggleTabs:function(index){


this.$vux.loading.show({
text: 'Loading'
})

var type="";
switch(index){
case 0:
type="crs";
break;
case 1:
type="vid";
break;
case 2:
type="qtn";
break;
}


this.$api.CollectCatalog(type)
.then(catalog_data => {//获取目录

if(catalog_data.data.Status!=0){
return ;
}

this.$api.CollectContent(type)
.then(content_data => {//获取收藏数据

if(content_data.data.Status!=0){
return ;
}

var data_course = new Array();
var idlist = new Array();

for(var i in content_data.data.Data.rows){
for(var j in catalog_data.data.Data.rows){

if(catalog_data.data.Data.rows[j].ID == content_data.data.Data.rows[i].CategoryID){

var data_in = {
name:catalog_data.data.Data.rows[j].Name,//分组名
id:content_data.data.Data.rows[i].ID,//收藏的id
parent_id:content_data.data.Data.rows[i].ContextID
}
data_course.push(data_in)
idlist.push(content_data.data.Data.rows[i].ContextID)
}
}
}
switch(type){
case "crs":

this.$api.GetCourse(idlist)
.then(data => {
if(data.data.Status!=0){
return ;
}

var show_data = new Array();
for(var t in data.data.Data){

var time = this.$api.TransformTime(data.data.Data[t].PlayTime);

var showdatas = {
type:data_course[t].name,
parent_id:data_course[t].parent_id,
collID:data_course[t].id,
IDCode:data.data.Data[t].IDCode,
imgurl:data.data.Data[t].Image,
name:data.data.Data[t].Name,
rescount:data.data.Data[t].ResCount,
playtime:time
}
show_data.push(showdatas)
}

this.dataCourse = show_data
})
break;
case "vid":

this.$api.GetRescourse(idlist)
.then(data => {
if(data.data.Status!=0){
return ;
}

var show_data = new Array();
for(var t in data.data.Data){
var time = this.$api.TransformTime(data.data.Data[t].PlayTime);

var showdatas = {
type:data_course[t].name,
parent_id:data_course[t].parent_id,
collID:data_course[t].id,
videoid:data.data.Data[t].ID,
courseid:data.data.Data[t].CourseIDCode,
chapterID:data.data.Data[t].ChapterID,
videofile:data.data.Data[t].VideoFile,
imgurl:data.data.Data[t].Logo,
name:data.data.Data[t].Name,
filesize:data.data.Data[t].FileSize,
playtime:time
}

show_data.push(showdatas)
}
this.dataVideo = show_data

})
break;
case "qtn":

this.$api.GETQuestion(idlist)
.then(data => {

var show_data = new Array();
for(var t in data.data.Data.rows){
var time = this.$api.TransformTime(data.data.Data.rows[t].PlayTime);

var showdatas = {
type:data_course[t].name,
parent_id:data_course[t].parent_id,
collID:data_course[t].id,
RelatedId:data.data.Data.rows[t].RelatedId2,//根据关联ID，获取视频id
title:data.data.Data.rows[t].Title,
id:data.data.Data.rows[t].ID,
courseid:data.data.Data.rows[t].RelatedId1,
videoid:data.data.Data.rows[t].RelatedId2
}

show_data.push(showdatas)
}
this.dataQtn = show_data
})
break;
}
})

})
this.nowIndex=index;

setTimeout(() => {
this.$vux.loading.hide()
}, 400)
},

deleteCousre:function(){

var deleteSure = confirm("确认取消收藏？")

if(deleteSure){
var id = event.target.id;
var test = document.getElementById(event.target.id);
var parent = test.parentElement.className;

this.$api.deleteConllect(id)
.then((data) => {
if(data.data.Status!=0){
return ;
}else{
alert("移除成功")

if(parent == "crs_img"){
this.toggleTabs(0);
}else if(parent == "vid_img"){
this.toggleTabs(1);
}else{
this.toggleTabs(2);
}
}
})
}
},

JumpVideo(url, IDCode,ChapterID,type) {
console.log(IDCode+"/"+ChapterID+"/"+type)
if(type == "qnt"){
var idlist = [];
idlist.push(ChapterID);
this.$api.GetRescourse(idlist)
.then((data) => {
if(data.data.Status !=0){
return ;
}
this.$router.push({
path: "/Index/Course",
name: "/Index/Course",
params: {
IDCode: IDCode,
ChapterID:data.data.Data[0].ChapterID,
level1: "我的收藏/",
}
})
})

}else{
this.$router.push({
path: "/Index/Course",
name: "/Index/Course",
params: {
IDCode: IDCode,
ChapterID:ChapterID,
level1: "我的收藏/",
}
})
}



},

}
}



// WEBPACK FOOTER //
// ./src/views/Personal/MyCollection.vue